import { Context, useContext } from 'react';

export function createContextFactory<T>(_context: Context<T>) {
  const context = useContext(_context);

  if (context === null) {
    const name = _context.displayName || '';
    throw new Error(`use${name}Context must be use inside ${name}Provider`);
  }
  return context;
}
